document.addEventListener('DOMContentLoaded', () => {
  // ========== ELEMENTS ==========
  const openBtn = document.getElementById('bb-open-review-modal');
  const modal = document.getElementById('bb-review-modal');
  const closeBtn = document.getElementById('bb-close-modal');
  const form = document.getElementById('bb-review-form');
  const reviewsList = document.getElementById('bb-reviews-list');
  const noReviewsMsg = document.getElementById('bb-no-reviews');
  const pagination = document.getElementById('bb-pagination');
  const totalReviewsEl = document.getElementById('bb-total-reviews');
  const ratingTextEl = document.getElementById('bb-rating-text');
  const overallStarsEl = document.getElementById('bb-overall-stars');

  // ========== STAR RATING INPUT ==========
  const ratingStars = document.querySelectorAll('#bb-rating-input .bb-rate-star');
  const ratingValue = document.getElementById('bb-rating-value');

  ratingStars.forEach(star => {
    star.addEventListener('mouseenter', () => {
      const val = parseInt(star.dataset.value);
      ratingStars.forEach(s => {
        s.classList.toggle('hover', parseInt(s.dataset.value) <= val);
      });
    });

    star.addEventListener('mouseleave', () => {
      ratingStars.forEach(s => s.classList.remove('hover'));
    });

    star.addEventListener('click', () => {
      const val = parseInt(star.dataset.value);
      ratingValue.value = val;
      ratingStars.forEach(s => {
        s.classList.toggle('filled', parseInt(s.dataset.value) <= val);
      });
    });
  });

  // ========== OPEN / CLOSE MODAL ==========
  openBtn?.addEventListener('click', () => {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  closeBtn?.addEventListener('click', closeModal);
  modal?.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // ========== LOAD SAVED REVIEWS ==========
  let reviews = JSON.parse(localStorage.getItem('bb_product_reviews') || '[]');

  function renderReviews() {
    // Clear list except the "no reviews" message
    const existing = reviewsList.querySelectorAll('.bb-review');
    existing.forEach(el => el.remove());

    if (reviews.length === 0) {
      noReviewsMsg.style.display = 'block';
      pagination.style.display = 'none';
      totalReviewsEl.textContent = '0 Reviews';
      ratingTextEl.textContent = '0 / 5 stars';
      updateOverallStars(0);
      return;
    }

    noReviewsMsg.style.display = 'none';
    
    // Show pagination only when there are reviews
    if (reviews.length > 0) {
      pagination.style.display = 'flex';
    }

    // Update total count
    totalReviewsEl.textContent = `${reviews.length} Review${reviews.length > 1 ? 's' : ''}`;

    // Calculate average
    const avg = (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1);
    ratingTextEl.textContent = `${avg} / 5 stars`;
    updateOverallStars(parseFloat(avg));

    // Render each review (newest first)
    reviews.slice().reverse().forEach(review => {
      const article = document.createElement('article');
      article.className = 'bb-review';
      article.dataset.rating = review.rating;
      article.innerHTML = `
        <div class="bb-review-header">
          <span class="bb-reviewer">${review.name}</span>
          <span class="bb-review-date">${review.date}</span>
        </div>
        <div class="bb-review-stars">${'★'.repeat(review.rating)}${'☆'.repeat(5 - review.rating)}</div>
        <h3 class="bb-review-title">${review.title}</h3>
        <p class="bb-review-body">${review.body}</p>
      `;
      reviewsList.appendChild(article);
    });
  }

  function updateOverallStars(rating) {
    const full = Math.floor(rating);
    overallStarsEl.innerHTML = '';
    for (let i = 1; i <= 5; i++) {
      const span = document.createElement('span');
      span.className = 'star' + (i <= full ? ' filled' : '');
      span.textContent = '★';
      overallStarsEl.appendChild(span);
    }
  }

  // Initial render
  renderReviews();

  // ========== FORM SUBMIT ==========
  form?.addEventListener('submit', (e) => {
    e.preventDefault();

    const rating = parseInt(ratingValue.value);
    const title = document.getElementById('bb-review-title').value.trim();
    const body = document.getElementById('bb-review-body').value.trim();
    const name = document.getElementById('bb-review-name').value.trim();

    if (!rating || !title || !body || !name) {
      alert('Please fill all required fields and select a rating.');
      return;
    }

    const today = new Date();
    const dateStr = `${String(today.getMonth()+1).padStart(2,'0')}/${String(today.getDate()).padStart(2,'0')}/${String(today.getFullYear()).slice(-2)}`;

    const newReview = {
      rating,
      title,
      body,
      name,
      date: dateStr,
      id: Date.now()
    };

    reviews.push(newReview);
    localStorage.setItem('bb_product_reviews', JSON.stringify(reviews));

    // Instantly show the new review
    renderReviews();

    // Reset form & close modal
    form.reset();
    ratingStars.forEach(s => s.classList.remove('filled'));
    ratingValue.value = '';
    closeModal();

    // Optional: scroll to the new review
    setTimeout(() => {
      document.getElementById('reviews').scrollIntoView({ behavior: 'smooth' });
    }, 300);
  });
});